/**
 * Created by zhj on 3/25/2016.
 */
'use strict';
angular.module('portalCommand', ['ui.router']).config(function ($stateProvider) {
  $stateProvider
    .state('portalCommand', {
      url: '/portalcommand',
      templateUrl: 'components/dashboard/portalCommand/portalCommand.tpl.html',
      controller: 'PortalCommandCtrl',
      resolve: {
        $title: function () {
          return 'BetoTrack';
        }
      }
    });

  $stateProvider
    .state('portalcommand', {
      parent: 'betotrack',
      url: '/portalcommand',
      ncyBreadcrumb: {
        label: 'Track'
      },
      views: {
        'content@app': {
          templateUrl: 'components/dashboard/portalCommand/portalCommand.tpl.html',
          controller: 'PortalCommandCtrl'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Fleet Management Dashboard';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/portalCommand/portalCommand.js